import React from "react";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
} from "@mui/material";
import {EMPTY_PRINT_VALUE} from "./printPreviewFormatters";

export interface PrintPreviewKeyValueRow {
    label: string;
    value: string;
}

interface Props {
    rows: PrintPreviewKeyValueRow[];
}

const PrintPreviewKeyValueTable = ({rows}: Props) => (
    <TableContainer
        component={Paper}
        variant="outlined"
        sx={{
            borderRadius: 1,
            boxShadow: "none",
            overflow: "hidden",
        }}
    >
        <Table size="small">
            <TableBody>
                {rows.map(row => {
                    const isEmpty = !row.value || row.value === EMPTY_PRINT_VALUE;

                    return (
                        <TableRow
                            key={row.label}
                            sx={{
                                "&:last-of-type td": {
                                    borderBottom: 0,
                                },
                            }}
                        >
                            <TableCell
                                sx={{
                                    borderColor: "divider",
                                    color: "text.secondary",
                                    fontSize: 13.5,
                                    px: 1.75,
                                    py: 1.25,
                                    whiteSpace: "nowrap",
                                    width: 108,
                                }}
                            >
                                {row.label}
                            </TableCell>
                            <TableCell
                                sx={{
                                    borderColor: "divider",
                                    color: isEmpty ? "text.disabled" : "text.primary",
                                    fontSize: 15,
                                    fontWeight: isEmpty ? 400 : 600,
                                    overflowWrap: "anywhere",
                                    px: 1.75,
                                    py: 1.25,
                                }}
                            >
                                {row.value || EMPTY_PRINT_VALUE}
                            </TableCell>
                        </TableRow>
                    );
                })}
            </TableBody>
        </Table>
    </TableContainer>
);

export default PrintPreviewKeyValueTable;
